import { AuthPageModel } from '@talbenmoshe/phrasier-auth-model';
import { createPhrasierAuthApp, type IPhrasierAuthFacade } from '@talbenmoshe/phrasier-auth-client';
import { WindowNavigator } from '../browser/WindowNavigator.js';

export function createBrowserAuthFacade(): IPhrasierAuthFacade {
  const bootstrap = requireAuthBootstrap();

  const model = new AuthPageModel({
    errorCode: bootstrap.errorCode,
    orgSlug: bootstrap.orgSlug,
    emailFieldValue: '',
    orgSlugFieldValue: ''
  });

  return createPhrasierAuthApp({ model, navigator: new WindowNavigator() });
}

function requireAuthBootstrap(): NonNullable<Window['__auth_bootstrap__']> {
  if (window.__auth_bootstrap__ === undefined) {
    throw new Error('Auth bootstrap data is unavailable');
  }

  return window.__auth_bootstrap__;
}
